import {
  StaffContractCatalogItemResponse,
  StaffEmployeeDocumentRequest,
  StaffEmployeeDocumentResponse,
  StaffEmploymentContractRequest,
  StaffEmploymentContractResponse,
} from "lib-klab-sdks";
import {
  ContractCatalogItem,
  EmployeeDocument,
  EmployeeDocumentRegisterRequest,
  EmploymentContract,
  EmploymentContractUpsertRequest,
} from "../../../domain/models/employment/contract.model";

export const mapContractCatalogItem = (
  source: StaffContractCatalogItemResponse,
): ContractCatalogItem => ({ ...source, numericValue: source.numericValue ?? null });

export const mapEmploymentContract = (
  source: StaffEmploymentContractResponse,
): EmploymentContract => ({
  id: source.contractId,
  employeeId: source.employeeId,
  contractTypeId: source.contractTypeId,
  continuityTypeId: source.continuityTypeId,
  renewalLimitId: source.renewalLimitId,
  workingModeId: source.workingModeId,
  startDate: source.startDate,
  endDate: source.endDate,
  currencyCode: source.currencyCode,
  baseSalary: source.baseSalary,
  performanceBonus: source.performanceBonus,
  computerAllowance: source.computerAllowance,
  internetAllowance: source.internetAllowance,
  electricityAllowance: source.electricityAllowance,
  transportationAllowance: source.transportationAllowance,
  contractUrl: source.contractUrl,
  fileSize: source.fileSize ?? null,
  status: source.statusCode,
  activatedAt: null,
  terminatedAt: null,
  terminationReason: null,
  createdAt: source.createdAt,
  updatedAt: source.updatedAt,
});

export const mapEmploymentContractRequest = (
  request: EmploymentContractUpsertRequest,
): StaffEmploymentContractRequest => ({ ...request });

export const mapEmployeeDocument = (
  source: StaffEmployeeDocumentResponse,
): EmployeeDocument => ({
  id: source.employeeDocumentId,
  employeeId: source.employeeId,
  typeCode: source.documentTypeCode,
  name: source.name,
  url: source.documentUrl,
  issuedAt: source.issuedAt,
  expiresAt: source.expiresAt,
  status: source.status,
  registeredByUserId: source.registeredByUserId,
  createdAt: source.createdAt,
  updatedAt: source.updatedAt,
});

export const mapEmployeeDocumentRequest = (
  request: EmployeeDocumentRegisterRequest,
): StaffEmployeeDocumentRequest => ({
  employeeId: request.employeeId,
  documentTypeCode: request.typeCode,
  name: request.name,
  documentUrl: request.url,
  issuedAt: request.issuedAt,
  expiresAt: request.expiresAt,
});
